import { FeatureProperties } from "@/components/local/Maps/data/identifier";
import { type ClassValue, clsx } from "clsx";
import { Feature, GeoJsonProperties, Geometry, Polygon } from "geojson";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const isPolygon = <P extends GeoJsonProperties>(
  feature: Feature<Geometry, P>
): feature is Feature<Polygon, P> => {
  return feature.geometry.type === "Polygon";
};

export const hasFeatureProperties = <G extends Geometry>(
  feature: Feature<G, GeoJsonProperties>
): feature is Feature<G, FeatureProperties> => {
  return Boolean(feature.properties && "status" in feature.properties);
};
